import styles from "./load.module.scss";

function AppLoader(): JSX.Element {
  return (
    <div className={styles.loader}>
      <div className={styles.boxLoad1}></div>
      <div className={styles.boxLoad2}></div>
      <div className={styles.boxLoad3}></div>
    </div>
  );
}

export default AppLoader;
